import { Box } from '@mui/material'
import { useFeatureFlag, SPLITS } from '@/helpers/useFeatureFlag'

import React from 'react'

import { VendorFilterType } from './type/component'
import { useTranslation } from 'react-i18next'
import { VendorSearchState } from '../../states/useVendorSearchState'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { SidebarAccordion } from '@/components/ui/Accordion'

type Props = {
  filters: VendorSearchState['filters']
  search: VendorSearchState['search']
}

const SupplierType: React.FC<Props> = ({ search, filters }) => {
  const showPantryVendorTypeDropdown = useFeatureFlag(SPLITS.USE_PANTRY_VENDOR_TYPE_DROPDOWN)

  const { t } = useTranslation()

  if (!showPantryVendorTypeDropdown) {
    return null
  }

  return (
    <Box sx={{ width: '100%' }}>
      <SidebarAccordion
        defaultExpanded
        expandIcon={<ExpandMoreIcon />}
        label={t('marketplace:vendorType')}
        summaryProps={{
          'aria-controls': 'supplier-type-content',
          id: 'supplier-type-header',
        }}
      >
        <VendorFilterType filters={filters} search={search} />
      </SidebarAccordion>
    </Box>
  )
}

export default SupplierType
